var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"edit-form"},[_c('cv-text-input',{attrs:{"id":"ll-edit-title","label":_vm.$t('sidebar.label-title'),"value":_vm.artwork.title},on:{"input":(e) => _vm.updateValue('title', e)}},[(!_vm.isValid.title)?_c('template',{slot:"invalid-message"},[_vm._v(_vm._s(_vm.$t('sidebar.max-number-of-characters')))]):_vm._e()],2),_c('cv-text-input',{staticClass:"edit-form__filename",attrs:{"label":_vm.$t('sidebar.label-file-name'),"value":_vm.artwork.fileName,"helper-text":_vm.$t('sidebar.file-name-description'),"disabled":true}}),_c('cv-multi-select',{attrs:{"id":"tags-dropdown","options":_vm.multiSelectOptionsFilteredBy,"value":_vm.multiSelectTags,"auto-filter":false,"filterable":true,"label":_vm.$tc('sidebar.tags', _vm.multiSelectTags.length, {
        number: _vm.multiSelectTags.length,
      }),"title":_vm.$t('sidebar.title')},on:{"filter":_vm.onFilter,"change":(tags) => {
        _vm.updateValue(
          'tags',
          tags.map((tagName) => ({ name: tagName }))
        );

        if (tags.map((tag) => tag.includes('(NEW)'))) {
          _vm.newTag = [];
        }
      }}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }